import * as React from "react";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { WizardComponent } from "../../../../Shared/Process/WizardComponent";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { CancelOrderAction } from "./Action/Action";
import { CancelOrder } from "./Component/CancelOrder";
import { Review } from "./Component/Review";
import { cancelOrderStepperName } from "./Resource/Content";

export class CancelOrderWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({ data: { cancel: [], batchInfo: null }, isLoading: false });
    }

    saveInstruction(from, to, toUrl, params, stepLength) {
        if (to == -1) {
            this.onExit();
        } else {
            CancelOrderAction.cancel(this.state.data, (d) => {
                this.setState({ onPosting: false, data: { batchInfo: d } });
                Navigator.navigateToAndPreserveQueryParameters(toUrl);
            });
        }
    }

    onExit() {
        window.location.href = `/clients/orders/orders.aspx?claccountid=${getQueryParameters()["claccountid"]}`;
    }

    onCancel() {
        this.onExit();
    }

    onSubmit() {}

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);

        this.stepperConfig = [
            {
                title: cancelOrderStepperName.cancel,
                url: Urls.get().CancelOrder,
                path: Contents.URLMap.cancel,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <CancelOrder {...this.getStepProps(0)} />,
            },
            {
                title: cancelOrderStepperName.review,
                type: StepType.Custom,
                url: Urls.get().CancelOrderReview,
                path: Contents.URLMap.review,
                needPrint: true,
                component: <Review {...this.getStepProps(1)} />,
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Cancel Order";
        processProps.needSplitHeader = null;
        processProps.onSave = null;
        processProps.goBacktoFirst = true;
        return processProps;
    }
}
